package com.bikompanion.domain

/**
 * A payload together with when its numbers were actually read from the operator.
 *
 * Availability data looks identical whether it arrived a second ago or came off disk from
 * yesterday, so anything that can be served from cache has to carry its own age rather than
 * leaving the caller to assume "I just got this, so it must be current".
 */
data class Snapshot<T>(
    val value: T,
    /** Wall clock time the upstream was last read successfully, in epoch milliseconds. */
    val updatedAtEpochMillis: Long,
    /** True when the refresh failed and this came off the local cache instead. */
    val isStale: Boolean,
    /**
     * True when the failure behind [isStale] was specifically the source refusing further
     * requests ([RateLimitedException]) — worth telling apart from being unreachable, since it
     * resolves on its own rather than needing a working connection.
     */
    val isRateLimited: Boolean = false,
)
